export default __webpack_public_path__ + "static/media/home_photo.235255d0.jpg";